(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('.product-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-current]');
      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.thumbs.forEach((thumb) =>
        thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.galleryThumb)))
      );
      this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
      this.next?.addEventListener('click', () => this.goTo(this.index + 1));
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
          });
        },
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((slide) => observer.observe(slide));
      this.setActive(0);
    }

    goTo(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({ left: this.slides[target].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.setActive(target);
    }

    setActive(index) {
      if (index < 0) return;
      this.index = index;
      this.thumbs.forEach((thumb, i) => {
        if (i === index) {
          thumb.setAttribute('aria-current', 'true');
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (this.counter) this.counter.textContent = String(index + 1);
      if (this.prev) this.prev.disabled = index === 0;
      if (this.next) this.next.disabled = index === this.slides.length - 1;
    }
  }

  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      const mainButton = document.querySelector('[data-main-buy] [data-amazon-button]');
      const footer = document.querySelector('footer');
      if (!mainButton) return;

      this.mainVisible = true;
      this.mainPassed = false;
      this.footerVisible = false;
      const mobile = window.matchMedia('(max-width: 989px)');

      const update = () => {
        const show = mobile.matches && !this.mainVisible && this.mainPassed && !this.footerVisible;
        this.hidden = !show;
        document.body.classList.toggle('has-sticky-buy', show);
        if (show) document.body.style.setProperty('--sticky-buy-height', `${this.offsetHeight}px`);
      };

      new IntersectionObserver(([entry]) => {
        this.mainVisible = entry.isIntersecting;
        // Only show once the shopper has scrolled past the main button, not before reaching it.
        this.mainPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      }).observe(mainButton);

      if (footer) {
        new IntersectionObserver(([entry]) => {
          this.footerVisible = entry.isIntersecting;
          update();
        }).observe(footer);
      }

      mobile.addEventListener('change', update);
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  if (!customElements.get('sticky-buy-bar')) customElements.define('sticky-buy-bar', StickyBuyBar);

  } catch(e) { console.error(e); }
})();
})();
